/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How teams are calculated`)
};

const es_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se calculan los equipos`)
};

const de_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie Teams berechnet werden`)
};

const nl_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe teams worden berekend`)
};

const fr_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les équipes sont calculées`)
};

const it_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono calcolati i team`)
};

const pt_br2_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as equipes são calculadas`)
};

const pt_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as equipas são calculadas`)
};

const ja_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームの計算方法`)
};

const zh_f1_apex_help_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车队计算方式`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_help_aria = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_help_aria(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_help_aria", locale)
	if (locale === "en") return en_f1_apex_help_aria(inputs)
	if (locale === "es") return es_f1_apex_help_aria(inputs)
	if (locale === "de") return de_f1_apex_help_aria(inputs)
	if (locale === "nl") return nl_f1_apex_help_aria(inputs)
	if (locale === "fr") return fr_f1_apex_help_aria(inputs)
	if (locale === "it") return it_f1_apex_help_aria(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_help_aria(inputs)
	if (locale === "pt") return pt_f1_apex_help_aria(inputs)
	if (locale === "ja") return ja_f1_apex_help_aria(inputs)
	return zh_f1_apex_help_aria(inputs)
};